// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface TestCaseAutomationProgressPayload
 */
export interface TestCaseAutomationProgressPayload {
    /**
     * 
     * @type {number}
     * @memberof TestCaseAutomationProgressPayload
     */
    testcase: number;
    /**
     * 
     * @type {number}
     * @memberof TestCaseAutomationProgressPayload
     */
    testcaserevision: number;
    /**
     * 
     * @type {number}
     * @memberof TestCaseAutomationProgressPayload
     */
    project: number;
    /**
     * Code to validate the test case automation request/response
     * @type {string}
     * @memberof TestCaseAutomationProgressPayload
     */
    code: string;
    /**
     * Step content, e.g., 'Click on the button', 'Verify the text', etc.
     * @type {string}
     * @memberof TestCaseAutomationProgressPayload
     */
    step: string;
    /**
     * Test case automation training status
     * @type {number}
     * @memberof TestCaseAutomationProgressPayload
     */
    automationStatus: number;
    /**
     * Step number in the test case, e.g., 0, 1, 2, 3 - (0 is the first step)
     * @type {number}
     * @memberof TestCaseAutomationProgressPayload
     */
    stepNumber: number;
    /**
     * Type of the step, e.g., 'i'='interaction', 'a'='assertion'
     * @type {string}
     * @memberof TestCaseAutomationProgressPayload
     */
    stepType: string;
    /**
     * Status of the step, e.g., 'inprogress', 'error', 'finish'
     * @type {string}
     * @memberof TestCaseAutomationProgressPayload
     */
    stepStatus: string;
    /**
     * Error message if the step status is 'error'
     * @type {string}
     * @memberof TestCaseAutomationProgressPayload
     */
    stepError?: string;
    /**
     * List of image urls related to the step
     * @type {Array<string>}
     * @memberof TestCaseAutomationProgressPayload
     */
    stepImages?: Array<string>;
    /**
     * URL of the training video for the test case (optional and applicable only for the last step with status 'finish' or 'error')
     * @type {string}
     * @memberof TestCaseAutomationProgressPayload
     */
    trainingVideoUrl?: string;
}

export function TestCaseAutomationProgressPayloadFromJSON(json: any): TestCaseAutomationProgressPayload {
    return {
        'testcase': json['testcase'],
        'testcaserevision': json['testcaserevision'],
        'project': json['project'],
        'code': json['code'],
        'step': json['step'],
        'automationStatus': json['automation_status'],
        'stepNumber': json['step_number'],
        'stepType': json['step_type'],
        'stepStatus': json['step_status'],
        'stepError': !exists(json, 'step_error') ? undefined : json['step_error'],
        'stepImages': !exists(json, 'step_images') ? undefined : json['step_images'],
        'trainingVideoUrl': !exists(json, 'training_video_url') ? undefined : json['training_video_url'],
    };
}

export function TestCaseAutomationProgressPayloadToJSON(value?: TestCaseAutomationProgressPayload): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'testcase': value.testcase,
        'testcaserevision': value.testcaserevision,
        'project': value.project,
        'code': value.code,
        'step': value.step,
        'automation_status': value.automationStatus,
        'step_number': value.stepNumber,
        'step_type': value.stepType,
        'step_status': value.stepStatus,
        'step_error': value.stepError,
        'step_images': value.stepImages,
        'training_video_url': value.trainingVideoUrl,
    };
}


